export default function getFormItemRules(arguments_) {
  const {
    required,
    whitespace
  } = arguments_;
  const rulesData = [];
  if (required) {
    rulesData.push({
      validator: (_, value) => {
        if (!value) {
          // eslint-disable-next-line prefer-promise-reject-errors
          return Promise.reject(`${_.field} is required`);
        }
        return Promise.resolve();
      },
    });
  }
  if (whitespace) {
    rulesData.push({
      validator(_, value) {
        if (
          value &&
          (!value.toString().substr(0, 1).trim() ||
            !value.toString().substr(-1).trim())
        ) {
          // eslint-disable-next-line prefer-promise-reject-errors
          return Promise.reject('Whitespace around the value not allowed');
        }
        return Promise.resolve();
      },
    });
  }
  return rulesData;
}
